import { LabelValueRow } from 'components/core-v2'
import React from 'react'

import { ConfirmedOrder } from './orders-types'

interface OrderConfirmedDetailsProps {
  order: ConfirmedOrder
}

export const OrderConfirmedDetails = ({ order }: OrderConfirmedDetailsProps) => (
  <>
    <LabelValueRow label="Order ID" value={order.orderId} />
    <LabelValueRow
      label="Order generated"
      value={new Date(order.createdDate).toLocaleDateString(undefined, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })}
    />
    <LabelValueRow label="Number of trades" value={order.individualOrders.length} />
  </>
)
